'use strict'

import { MAX_SYSTEM_MESSAGE_WEBHOOKS_PER_ORGANIZATION } from '../js/constants'

angular
  .module('surfsightApp.controllers')
  .controller('organizationWebhooksSettingsEditController', [
    '$scope',
    '$mdDialog',
    '$rootScope',
    '$mdColors',
    'UnitSystem',
    '$filter',
    '$mdToast',
    '$localStorage',
    function (
      $scope,
      $mdDialog,
      $rootScope,
      $mdColors,
      UnitSystem,
      $filter,
      $mdToast,
      $localStorage
    ) {
      $scope.themePrimary = $mdColors.getThemeColor('primary')
      const $translate = $filter('translate')
      $scope.themeAccent = $mdColors.getThemeColor('accent')
      $scope.showMessageToast = function (message) {
        const toast = $mdToast
          .simple()
          .textContent(message)
          .action($translate('ok'))
          .position('top right')
          .parent(
            document.getElementById('organization-webhooks-setting-container')
          )
          .hideDelay(10000)
          .actionKey('F1')
        $mdToast
          .show(toast)
          .then(function (response) {
            if (response == 'ok') {
              //
            }
          })
          .catch(() => {})
      }

      $scope.dataProfileLimitRange = {
        min: 10,
        max: 100
      }
      $scope.dataUsageLimitRange = {
        min: 0.1,
        max: 20
      }

      $scope.eventWebhooks = {
        url1: $rootScope.organizationSettings.organizationEventWebhookURLs[0],
        url2: $rootScope.organizationSettings.organizationEventWebhookURLs[1],
        url3: $rootScope.organizationSettings.organizationEventWebhookURLs[2]
      }

      $scope.eventWebhooksConfigNotifyMediaAvailable =
        $rootScope.organizationSettings.organizationEventWebhookConfig &&
        $rootScope.organizationSettings.organizationEventWebhookConfig
          .notifyMediaAvailable &&
        $rootScope.organizationSettings.organizationEventWebhookConfig
          .notifyMediaAvailable.isEnabled

      $scope.alarmsWebhooksConfigSubscribeForAlarmUpdates =
        $rootScope.organizationSettings.organizationAlarmsWebhookConfig &&
        $rootScope.organizationSettings.organizationAlarmsWebhookConfig
          .subscribeForAlarmUpdates &&
        $rootScope.organizationSettings.organizationAlarmsWebhookConfig
          .subscribeForAlarmUpdates.isEnabled

      $scope.gpsWebhooks = {
        url1: $rootScope.organizationSettings.organizationGpsWebhookURLs[0],
        url2: $rootScope.organizationSettings.organizationGpsWebhookURLs[1],
        url3: $rootScope.organizationSettings.organizationGpsWebhookURLs[2]
      }
      $scope.alarmsWebhooks = {
        url1: $rootScope.organizationSettings.organizationAlarmsWebhookURLs[0],
        url2: $rootScope.organizationSettings.organizationAlarmsWebhookURLs[1],
        url3: $rootScope.organizationSettings.organizationAlarmsWebhookURLs[2]
      }
      $scope.systemMessagesWebhooks = Array.from(
        new Array(MAX_SYSTEM_MESSAGE_WEBHOOKS_PER_ORGANIZATION)
      )
        .map(() => ({
          url: '',
          config: {
            dataProfile: {
              isEnabled: false,
              dataProfileLimit: null // number
            },
            deviceStatus: {
              isEnabled: false
            },
            deviceConfig: {
              isEnabled: false
            },
            deviceBillingStatus: {
              isEnabled: false
            },
            deviceRemoved: {
              isEnabled: false
            },
            auxiliaryCamerasConnectionStatus: {
              isEnabled: false
            },
            auxiliaryCamerasPairingStatus: {
              isEnabled: false
            },
            privacyMode: {
              isEnabled: false
            },
            dataUsage: {
              isEnabled: false,
              dataPlan: null, // number
              dataThresholdInput: null,
              dataThresholds: [1] // default
            },
            dynamicAdjust: {
              isEnabled: false
            }
          }
        }))
        .map((systemMessageWebhook, index) => {
          const organizationSystemWebhook =
            $rootScope.organizationSettings.organizationSystemMessagesWebhook[
              index
            ]
          return {
            ...systemMessageWebhook,
            ...(organizationSystemWebhook && {
              ...organizationSystemWebhook,
              config: {
                ...systemMessageWebhook.config,
                ...Object.keys(systemMessageWebhook.config).reduce(
                  (
                    systemMessageWebhookConfig,
                    systemMessageWebhookConfigKey
                  ) => ({
                    ...systemMessageWebhookConfig,
                    [systemMessageWebhookConfigKey]: {
                      ...systemMessageWebhook.config[
                        systemMessageWebhookConfigKey
                      ],
                      ...organizationSystemWebhook.config[
                        systemMessageWebhookConfigKey
                      ]
                    }
                  }),
                  {}
                )
              }
            })
          }
        })
      $scope.cancelWebhookSettings = () => {
        $mdDialog.cancel()
      }
      $scope.validateUrlInput = input => {
        const r = window.validateUrl(input)
      }
      $scope.saveWebhookSettings = () => {
        const eventWebhookUrl = Object.values($scope.eventWebhooks).filter(
          e => e
        )

        const eventWebhookConfig = {
          notifyMediaAvailable: {
            isEnabled: !!$scope.eventWebhooksConfigNotifyMediaAvailable
          }
        }

        const gpsWebhookUrl = Object.values($scope.gpsWebhooks).filter(e => e)
        const alarmsWebhookUrl = Object.values($scope.alarmsWebhooks).filter(
          e => e
        )

        const alarmsWebhookConfig = {
          subscribeForAlarmUpdates: {
            isEnabled: !!$scope.alarmsWebhooksConfigSubscribeForAlarmUpdates
          }
        }

        $scope.eventWebhooksNotValid = eventWebhookUrl.some(
          url => !window.validateUrl(url)
        )
        $scope.gpsWebhooksNotValid = gpsWebhookUrl.some(
          url => !window.validateUrl(url)
        )
        $scope.alarmsWebhooksNotValid = alarmsWebhookUrl.some(
          url => !window.validateUrl(url)
        )

        let valid = true
        if (
          gpsWebhookUrl.length &&
          Array.from(new Set(gpsWebhookUrl)).length < gpsWebhookUrl.length
        ) {
          $scope.showMessageToast('Each GPS webhook must be unique')
          valid = false
        }
        if (
          eventWebhookUrl.length &&
          Array.from(new Set(eventWebhookUrl)).length < eventWebhookUrl.length
        ) {
          $scope.showMessageToast('Each Event webhook must be unique')
          valid = false
        }
        if (
          alarmsWebhookUrl.length &&
          Array.from(new Set(alarmsWebhookUrl)).length < alarmsWebhookUrl.length
        ) {
          $scope.showMessageToast('Each Alarms webhook must be unique')
          valid = false
        }

        const systemMessagesWebhooks = []
        const uniqueUrls = []
        for (let i = 0; i < $scope.systemMessagesWebhooks.length; i++) {
          // protection from empty urls
          if (!$scope.systemMessagesWebhooks[i].url.trim().length) {
            continue
          }
          uniqueUrls.push($scope.systemMessagesWebhooks[i].url)
          const systemMessagesWebhook = $scope.systemMessagesWebhooks[i]
          systemMessagesWebhooks.push({
            url: systemMessagesWebhook.url,
            config: {
              dataProfile: {
                isEnabled: systemMessagesWebhook.config.dataProfile.isEnabled,
                ...(![null, undefined].includes(
                  systemMessagesWebhook.config.dataProfile.dataProfileLimit
                )
                  ? {
                      dataProfileLimit:
                        systemMessagesWebhook.config.dataProfile
                          .dataProfileLimit
                    }
                  : {})
              },
              deviceStatus: {
                isEnabled: systemMessagesWebhook.config.deviceStatus.isEnabled
              },
              deviceConfig: {
                isEnabled: systemMessagesWebhook.config.deviceConfig.isEnabled
              },
              deviceBillingStatus: {
                isEnabled:
                  systemMessagesWebhook.config.deviceBillingStatus.isEnabled
              },
              deviceRemoved: {
                isEnabled: systemMessagesWebhook.config.deviceRemoved.isEnabled
              },
              auxiliaryCamerasConnectionStatus: {
                isEnabled:
                  systemMessagesWebhook.config.auxiliaryCamerasConnectionStatus
                    .isEnabled
              },
              auxiliaryCamerasPairingStatus: {
                isEnabled:
                  systemMessagesWebhook.config.auxiliaryCamerasPairingStatus
                    .isEnabled
              },
              privacyMode: {
                isEnabled: systemMessagesWebhook.config.privacyMode.isEnabled
              },
              dataUsage: {
                isEnabled: systemMessagesWebhook.config.dataUsage.isEnabled,
                ...(![null, undefined].includes(
                  systemMessagesWebhook.config.dataUsage.dataPlan
                ) && {
                  dataPlan: systemMessagesWebhook.config.dataUsage.dataPlan
                }),
                ...(![null, undefined].includes(
                  systemMessagesWebhook.config.dataUsage.dataThresholds
                ) &&
                  systemMessagesWebhook.config.dataUsage.dataThresholds.length >
                    0 && {
                    dataThresholds:
                      systemMessagesWebhook.config.dataUsage.dataThresholds
                  })
              },
              dynamicAdjust: {
                isEnabled: systemMessagesWebhook.config.dynamicAdjust.isEnabled
              }
            }
          })
        }

        $scope.systemMessagesWebhooksUrlNotValid = uniqueUrls.some(
          url => !window.validateUrl(url)
        )

        if (
          uniqueUrls.length &&
          Array.from(new Set(uniqueUrls)).length < uniqueUrls.length
        ) {
          $scope.showMessageToast('Each System Messages webhook must be unique')
          valid = false
        }

        for (let i = 0; i < $scope.systemMessagesWebhooks.length; i++) {
          // protection from values entered not in range
          if (
            $scope.systemMessagesWebhooks[i].url &&
            $scope.systemMessagesWebhooks[i].config.dataProfile.isEnabled &&
            !$scope.systemMessagesWebhooks[i].config.dataProfile
              .dataProfileLimit
          ) {
            $scope.showMessageToast(
              `Data Profile Limit must be between ${$scope.dataProfileLimitRange.min} and ${$scope.dataProfileLimitRange.max} only`
            )
            valid = false
          }
          if (
            $scope.systemMessagesWebhooks[i].url &&
            $scope.systemMessagesWebhooks[i].config.dataUsage
          ) {
            const dataUsage = $scope.systemMessagesWebhooks[i].config.dataUsage
            // If dataPlan exists, validate its range
            if (
              ![null, undefined].includes(
                $scope.systemMessagesWebhooks[i].config.dataUsage.dataPlan
              ) &&
              (dataUsage.dataPlan < $scope.dataUsageLimitRange.min ||
                dataUsage.dataPlan > $scope.dataUsageLimitRange.max)
            ) {
              $scope.showMessageToast($translate('dataPlanValuesError'))
              $scope.systemMessagesWebhooks[i].config.dataUsage.isEnabled = true
              valid = false
              return
            }
          }
        }
        const data = {
          gpsWebhookUrl,
          eventWebhookUrl,
          eventWebhookConfig,
          alarmsWebhookUrl,
          alarmsWebhookConfig,
          systemMessagesWebhook: systemMessagesWebhooks
        }
        if (
          valid &&
          !$scope.eventWebhooksNotValid &&
          !$scope.gpsWebhooksNotValid &&
          !$scope.alarmsWebhooksNotValid &&
          !$scope.systemMessagesWebhooksUrlNotValid
        ) {
          $mdDialog.hide(data)
        }
      }
      $scope.cancelWebhooksSettings = () => {
        $mdDialog.cancel()
      }
      $scope.isRestrictedUser =
        $localStorage.userDetails.accessLevel === 'viewer'

      $scope.addDataThresholdOnEnter = function (index, event) {
        if (event && event.key !== 'Enter' && event.key !== ' ') return
        let val = parseFloat(
          $scope.systemMessagesWebhooks[index].config.dataUsage
            .dataThresholdInput
        )
        if (!isNaN(val)) {
          val = parseFloat(val.toFixed(2))
        }
        const thresholds =
          $scope.systemMessagesWebhooks[index].config.dataUsage
            .dataThresholds || []

        if (isNaN(val) || val < 0.1 || val > 20) {
          $scope.showMessageToast($translate('dataThresholdValuesError'))
          return
        } else if (thresholds.includes(val)) {
          $scope.showMessageToast($translate('uniqueDataThresholdError'))
          return
        } else if (thresholds.length >= 20) {
          $scope.showMessageToast($translate('maxDataThresholdError'))
          return
        }

        thresholds.push(val)
        thresholds.sort((a, b) => a - b)
        $scope.systemMessagesWebhooks[
          index
        ].config.dataUsage.dataThresholds = thresholds
        $scope.systemMessagesWebhooks[
          index
        ].config.dataUsage.dataThresholdInput = null

        if (event) event.preventDefault()
      }
      $scope.removeThreshold = function (index, value) {
        const thresholds =
          $scope.systemMessagesWebhooks[index].config.dataUsage.dataThresholds
        const idx = thresholds.indexOf(value)
        if (idx !== -1) {
          thresholds.splice(idx, 1)
        }
      }
    }
  ])
